export const getUrlName = (url) => {
  if (!url) return ''
  const woHttp = url.replace(/^http(s?):\/\//i, '').replace('www.', '')
  const end = woHttp.lastIndexOf('.')
  return woHttp.substring(0, end)
}
